import React from 'react';
import EllipsisText from '../components/EllipsisText';

type LexicalRendererHeader = {
    text: string;
};


export default (prop: LexicalRendererHeader) => {
    const {text} = prop;
    return (
        <EllipsisText text={text} sx={{ flexGrow: 2 }} />
    );
};